import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { Logger } from '../../shared/services/logger';
import { Toaster } from '../../shared/services/toaster';

export const errorHandlerInterceptor: HttpInterceptorFn = (req, next) => {
  const toasterService = inject(Toaster);
  const loggerService = inject(Logger);

  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      const { message } = err?.error;
      toasterService.error(message || 'Something went wrong!');
      loggerService.error(`GLOBAL ERROR : $${(JSON.stringify(err.error), message)}`);
      return throwError(() => err);
    })
  );
};
